export default __webpack_public_path__ + "static/media/work+.46d6f8af.svg";